<template>
  <footer class="footer">
    <!-- Main Footer -->
    <div class="footer__main">
      <div class="container">
        <div class="footer__grid">
          <!-- Company Info -->
          <div class="footer__company">
            <router-link to="/" class="footer__logo">
              <div class="footer__logo-icon">
                <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="40" height="40" rx="8" fill="currentColor"/>
                  <path d="M12 28V12h4l4 10 4-10h4v16h-3V17l-4 11h-2l-4-11v11h-3z" fill="#0d1b2a"/>
                </svg>
              </div>
              <span class="footer__logo-text">Omega Metal Industries</span>
            </router-link>
            <p class="footer__description">
              A leading industrial fabrication and machining company serving the oil & gas sector across Saudi Arabia and neighboring countries since 1996.
            </p>
            <div class="footer__certifications">
              <span class="footer__cert-badge">API Certified (Pending)</span>
              <span class="footer__cert-badge">Est. 1996</span>
            </div>
          </div>

          <!-- Quick Links -->
          <div class="footer__links">
            <h4 class="footer__title">Quick Links</h4>
            <ul class="footer__list">
              <li><router-link to="/about">About Us</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
              <li><router-link to="/capabilities">Capabilities</router-link></li>
              <li><router-link to="/industries">Industries</router-link></li>
              <li><router-link to="/gallery">Gallery</router-link></li>
              <li><router-link to="/quality">Quality</router-link></li>
              <li><router-link to="/faq">FAQ</router-link></li>
            </ul>
          </div>

          <!-- Services -->
          <div class="footer__links">
            <h4 class="footer__title">Services</h4>
            <ul class="footer__list">
              <li><router-link to="/services/precision-machining">Precision Machining</router-link></li>
              <li><router-link to="/services/fabrication">Fabrication</router-link></li>
              <li><router-link to="/services/repair-maintenance">Repair & Maintenance</router-link></li>
              <li><router-link to="/services/grinding-finishing">Grinding & Finishing</router-link></li>
              <li><router-link to="/services/laser-cutting">Laser & Water Jet Cutting</router-link></li>
              <li><router-link to="/services/reverse-engineering">Reverse Engineering</router-link></li>
            </ul>
          </div>

          <!-- Contact Info -->
          <div class="footer__contact">
            <h4 class="footer__title">Contact Us</h4>
            <ul class="footer__contact-list">
              <li class="footer__contact-item">
                <svg class="footer__contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                <span>Dharan Jubail Expressway, 8219<br>Dammam — KSA</span>
              </li>
              <li class="footer__contact-item">
                <svg class="footer__contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <a href="tel:+966545538885">+966 54 5538885</a>
              </li>
              <li class="footer__contact-item">
                <svg class="footer__contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                <a href="mailto:Sulaiman@omegamet.com">Sulaiman@omegamet.com</a>
              </li>
              <li class="footer__contact-item">
                <svg class="footer__contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
                <span>Mon-Thu: 8AM - 5PM<br>Fri: 8AM - 12PM</span>
              </li>
            </ul>

            <!-- Social Links -->
            <div class="footer__social">
              <a href="https://linkedin.com" target="_blank" rel="noopener" class="footer__social-link" aria-label="LinkedIn">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener" class="footer__social-link" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
                </svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener" class="footer__social-link" aria-label="Twitter">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener" class="footer__social-link" aria-label="YouTube">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="footer__bottom">
      <div class="container">
        <div class="footer__bottom-content">
          <p class="footer__copyright">
            &copy; {{ currentYear }} Omega Metal Industries. All rights reserved.
          </p>
          <div class="footer__bottom-links">
            <router-link to="/privacy">Privacy Policy</router-link>
            <router-link to="/terms">Terms of Service</router-link>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'AppFooter',
  setup() {
    const currentYear = computed(() => new Date().getFullYear())

    return {
      currentYear
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables' as *;
@use '@/assets/scss/mixins' as *;

.footer {
  background-color: $primary-900;
  color: $primary-200;

  &__main {
    padding: $spacing-12 0;

    @include lg {
      padding: $spacing-16 0;
    }
  }

  &__grid {
    display: grid;
    gap: $spacing-8;

    @include md {
      grid-template-columns: repeat(2, 1fr);
    }

    @include lg {
      grid-template-columns: 1.5fr 1fr 1fr 1.5fr;
    }
  }

  &__company {
    @include md {
      grid-column: span 2;
    }

    @include lg {
      grid-column: span 1;
    }
  }

  &__logo {
    display: inline-flex;
    align-items: center;
    gap: $spacing-3;
    margin-bottom: $spacing-4;
    text-decoration: none;
  }

  &__logo-icon {
    width: 40px;
    height: 40px;
    color: $accent-500;
  }

  &__logo-text {
    font-size: $font-size-xl;
    font-weight: $font-weight-bold;
    color: $white;
  }

  &__description {
    margin-bottom: $spacing-4;
    font-size: $font-size-sm;
    line-height: $line-height-relaxed;
  }

  &__certifications {
    display: flex;
    flex-wrap: wrap;
    gap: $spacing-2;
  }

  &__cert-badge {
    padding: $spacing-1 $spacing-2;
    font-size: $font-size-xs;
    font-weight: $font-weight-medium;
    color: $white;
    background-color: rgba($white, 0.1);
    border-radius: $radius-sm;
  }

  &__title {
    margin-bottom: $spacing-4;
    font-size: $font-size-base;
    font-weight: $font-weight-semibold;
    color: $white;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  &__list {
    li {
      margin-bottom: $spacing-2;
    }

    a {
      font-size: $font-size-sm;
      color: $primary-300;
      text-decoration: none;
      transition: color $transition-fast;

      &:hover {
        color: $accent-400;
      }
    }
  }

  &__contact-list {
    margin-bottom: $spacing-4;
  }

  &__contact-item {
    display: flex;
    gap: $spacing-3;
    margin-bottom: $spacing-4;
    font-size: $font-size-sm;

    a {
      color: $primary-300;
      text-decoration: none;
      transition: color $transition-fast;

      &:hover {
        color: $accent-400;
      }
    }
  }

  &__contact-icon {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    color: $accent-500;
  }

  &__social {
    display: flex;
    gap: $spacing-3;
  }

  &__social-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    color: $primary-300;
    background-color: rgba($white, 0.1);
    border-radius: $radius-full;
    transition: all $transition-fast;

    &:hover {
      color: $white;
      background-color: $accent-500;
    }

    svg {
      width: 18px;
      height: 18px;
    }
  }

  &__bottom {
    padding: $spacing-4 0;
    border-top: 1px solid rgba($white, 0.1);
  }

  &__bottom-content {
    display: flex;
    flex-direction: column;
    gap: $spacing-4;
    text-align: center;

    @include md {
      flex-direction: row;
      justify-content: space-between;
      text-align: left;
    }
  }

  &__copyright {
    font-size: $font-size-sm;
    margin: 0;
  }

  &__bottom-links {
    display: flex;
    gap: $spacing-6;
    justify-content: center;

    a {
      font-size: $font-size-sm;
      color: $primary-300;
      text-decoration: none;
      transition: color $transition-fast;

      &:hover {
        color: $accent-400;
      }
    }
  }
}
</style>
